import React,{useState} from 'react'
import logo from "../../assets/main-logo.png"
import {NavLink, Link} from "react-router-dom"
import '@fortawesome/fontawesome-free/css/all.min.css';
import './Navbar.css'


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false); // Dropdown toggle
  

  return (
    <header>
      <div className='container'>
        <div className='menus'>
          <Link to="/"><img src={logo} alt="logo" className='logo'/></Link>
          <nav>
            <ul className={isOpen ? "display" : ""}>
              <div className="btn" onClick={() => setIsOpen(false)}>
                <i className='fas fa-times close-btn'></i>
              </div>
              <li>
                <NavLink to="/" onClick={() =>window.scrollTo(0,0) }>Home</NavLink>
              </li>
              <li>
                <NavLink to="/about" onClick={() =>window.scrollTo(0,0) }>About</NavLink>
              </li>
              <li>
                <NavLink to="/contact" onClick={() =>window.scrollTo(0,0) }>Contact Us</NavLink>
              </li>
  
              {/* Only One Dropdown Menu - Services */}
              <li className="dropdown">
                <span className="dropbtn" onClick={() => setDropdownOpen(!dropdownOpen)}>
                  More <i className="fas fa-caret-down"></i>
                </span>
                {dropdownOpen && (
                  <ul className="dropdown-content">
                    <li><NavLink to="/privacy&policy" onClick={() =>window.scrollTo(0,0) }>Privacy & Policy</NavLink></li>
                    <li><NavLink to="/terms&conditions" onClick={() =>window.scrollTo(0,0) }>T & C</NavLink></li>
                    
                  </ul>
                )}
              </li>
            </ul>
        
          </nav>
          <div className="btn" onClick={() => setIsOpen(true)}>
            <i className='fas fa-bars menu-btn'></i>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Navbar
